module.exports = __webpack_public_path__ + "img/2f9fe3b.jpg";